/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Result_Ready_HelpInputs */

const en_tts_tool_result_ready_help = /** @type {(inputs: Tts_Tool_Result_Ready_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the 24-hour read-along link to play the generated audio.`)
};

const es_tts_tool_result_ready_help = /** @type {(inputs: Tts_Tool_Result_Ready_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre el enlace de 24 horas para reproducir el audio generado.`)
};

/**
* | output |
* | --- |
* | "Open the 24-hour read-along link to play the generated audio." |
*
* @param {Tts_Tool_Result_Ready_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_result_ready_help = /** @type {((inputs?: Tts_Tool_Result_Ready_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Result_Ready_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_result_ready_help(inputs)
	return en_tts_tool_result_ready_help(inputs)
});